import { Field } from 'redux-form';
import { isRequired } from '../../../../../../../../util/validators';
import * as React from 'react';
import { CancellationReasons } from '../../../../../../../../services/mta/models';
import { map } from 'lodash';
import FieldFormControl from '../../../../../../../../components/FieldFormControl';

export const CancelReasons = ({ handleOnchange, selection }) => {

  const reasons = [
    { label: 'NOT TRAVELLING SOON', value: CancellationReasons.NOT_TRAVELLING_SOON },
    { label: 'BOUGHT A DUPLICATE POLICY', value: CancellationReasons.BOUGHT_A_DUPLICATE_POLICY },
    { label: 'POOR SERVICE', value: CancellationReasons.POOR_SERVICE },
    { label: 'IT\'S TOO EXPENSIVE', value: CancellationReasons.TOO_EXPENSIVE },
    { label: 'COVER OR LIMITS AREN\'T SUITABLE', value: CancellationReasons.COVER_NOT_SUITABLE },
    { label: 'OTHER', value: CancellationReasons.OTHER },
  ];

  return (
    <>
      <div className={'cancellation-selection-container'}>
        {map(reasons, (reason, key) => {
          const isSelected = selection === reason.value;
          const isSingleLine = reason.value !== CancellationReasons.BOUGHT_A_DUPLICATE_POLICY && reason.value !== CancellationReasons.COVER_NOT_SUITABLE;
          let selectionClass = `trip-type-btn ${key}`

          if (isSelected) {
            selectionClass += ' selected'
          }

          if (isSingleLine) {
            selectionClass += ' single'
          }

          return (
            <div className={isSelected ? 'cancellation-title-selection selected' : 'cancellation-title-selection'}
                 key={key}>
              <Field
                name={`data.meta.reason.cancellation_reason`}
                id={key + '-btn'}
                type="radio"
                value={reason.value}
                onChange={handleOnchange}
                component={FieldFormControl}
                validate={[isRequired]}
              >
                <div className={selectionClass}>
                  <div>
                    {reason.label}
                  </div>
                </div>
              </Field>

            </div>
          )
        })}
      </div>
    </>
  )
}
